module.exports = __webpack_public_path__ + "img/aaos.3aae679b.png";